import { render, staticRenderFns } from "./HeaderClientView.vue?vue&type=template&id=384bf7d8&scoped=true&"
import script from "./HeaderClientView.vue?vue&type=script&lang=js&"
export * from "./HeaderClientView.vue?vue&type=script&lang=js&"
import style0 from "./HeaderClientView.vue?vue&type=style&index=0&id=384bf7d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384bf7d8",
  null
  
)

export default component.exports